export class ApiError extends Error {
  constructor(message, options = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = options.status || 0;
    this.payload = options.payload;
    this.url = options.url;
  }
}

// 权益门禁错误：后端对受保护接口返回 403 { error: 'entitlement_required', entitlement }。
// 通用机制见 docs/entitlement-gate.md。
export const isEntitlementError = (err) => {
  return (
    err instanceof ApiError && err.status === 403 && err.payload?.error === 'entitlement_required'
  );
};

// 取出被拦的权益键（如 'neican'）；非权益错误返回 null。
export const entitlementKeyOf = (err) => {
  return isEntitlementError(err) ? err.payload.entitlement || null : null;
};
